import DecisionTableAdapter from './DecisionTableAdapter';

export default {
  __init__: [ 'decisionTableAdapter' ],
  decisionTableAdapter: [ 'type', DecisionTableAdapter ]
};